import { Button } from '@mui/material'
import Crypto from 'crypto'
import { useSelector } from 'react-redux'

export function PaymentMultiple({ finalData, disabled }) {

  const state = useSelector(state => state)

  function getTypeCarteID(item) {
    // Tennis liberté
    if (item.activite.ACT_ID === '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803') return 3

    // carte passeport ou item de la carte passeport
    if (item.passeport) return 2

    // solo et solo +
    return 1
  }

  function getTypePeriodeID(item) {
    switch (item.periode.libelle) {
      case 'mois': return 1
      case 'trimestre': return 2
      case 'saison': return 3
      case 'annee': return 4
    }
  }

  function getItemPrice(item) {

    // Si c'est une carte passeport
    if (item.passeport) return item.price

    // Si c'est un item de la carte passeport
    if (item.isInPasseport) return 0

    // Si autre
    return item.periode.price
  }

  function randomTransId() {
    let trans_id = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (var i = 0; i < 6; i++) {
      trans_id += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return trans_id
  }

  function convertsha1(data) {
    return Crypto.createHash('sha1').update(data).digest('hex')
  }

  const today = new Date()
  const year = '' + today.getFullYear()
  const month = (today.getMonth() + 1).toString().length == 1 ? 0 + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString()
  const day = today.getDate().toString().length == 1 ? 0 + today.getDate().toString() : today.getDate().toString()
  const hour = today.getHours().toString().length == 1 ? 0 + today.getHours().toString() : today.getHours().toString()
  const minute = today.getMinutes().toString().length == 1 ? 0 + today.getMinutes().toString() : today.getMinutes().toString()
  const seconde = today.getSeconds().toString().length == 1 ? 0 + today.getSeconds().toString() : today.getSeconds().toString()
  const vads_trans_date = year + month + day + hour + minute + seconde

  const vads_trans_id = randomTransId()

  const vads_action_mode = 'INTERACTIVE'
  const vads_amount = finalData.total * 100
  const vads_ctx_mode = process.env.REACT_APP_MODE
  const vads_currency = '978'
  const vads_cust_email = state.user.mail
  const vads_cust_first_name = state.user.prenom
  const vads_cust_last_name = state.user.nom
  const vads_page_action = 'PAYMENT'
  const montantx10 = finalData.total / 10
  const vads_payment_config = 'MULTI:first=' + finalData.total * 100 / 10 + ';count=10;period=30'
  const vads_site_id = process.env.REACT_APP_SITE_ID
  const vads_version = 'V2'
  const signature = process.env.REACT_APP_SIGNATURE
  const vads_redirect_error_message = 'Vous allez être redirigé vers votre site marchand'
  const vads_redirect_error_timeout = '10'
  const vads_redirect_success_message = 'Vous allez être redirigé vers votre site marchand'
  const vads_redirect_success_timeout = '10'
  const vads_return_mode = 'GET'
  const vads_cust_legal_name = state.user.numero
  const vads_url_check = process.env.REACT_APP_API_PATH + 'api/new-souscription/insertAllx10'
  const vads_ext_info_transac = JSON.stringify(finalData.activite.map(item => ({
    liID: item.licencie.id,
    liMail: state.user.mail,
    centre: item.centre.CNT_ID,
    category: item.periode.prices.TAR_CAT_ID || item.periode.prices.CAT_ID,
    typeAbo: getTypeCarteID(item),
    cours: item.crenaux?.CO_ID,
    dateDeb: item.periode.dates.DATE_DEBUT,
    dateFin: item.periode.dates.DATE_FIN,
    periode: getTypePeriodeID(item),
    activity: item.activite.ACT_ID,
    activityName: item.activite.ACT_LIBELLE,
    montant: getItemPrice(item)
  })))

  let data = `${vads_action_mode}+${vads_amount}+${vads_ctx_mode}+${vads_currency}+${vads_cust_email}+${vads_cust_first_name}+${vads_cust_last_name}+${vads_cust_legal_name}+${vads_ext_info_transac}+${vads_page_action}+${vads_payment_config}+${vads_redirect_error_message}+${vads_redirect_error_timeout}+${vads_redirect_success_message}+${vads_redirect_success_timeout}+${vads_return_mode}+${vads_site_id}+${vads_trans_date}+${vads_trans_id}+${vads_url_check}+${vads_version}+${signature}`
  const signatureSHA1 = convertsha1(data)

  return (
    <form method="POST" action="https://secure.payzen.eu/vads-payment/">
      <input type="hidden" name="vads_action_mode" value={vads_action_mode} />
      <input type="hidden" name="vads_amount" value={vads_amount} />
      <input type="hidden" name="vads_ctx_mode" value={vads_ctx_mode} />
      <input type="hidden" name="vads_currency" value={vads_currency} />
      <input type="hidden" name="vads_cust_email" value={vads_cust_email} />
      <input type="hidden" name="vads_cust_first_name" value={vads_cust_first_name} />
      <input type="hidden" name="vads_cust_last_name" value={vads_cust_last_name} />
      <input type="hidden" name="vads_cust_legal_name" value={vads_cust_legal_name} />
      <input type="hidden" name="vads_page_action" value={vads_page_action} />
      <input type="hidden" name="vads_payment_config" value={vads_payment_config} />
      <input type="hidden" name="vads_redirect_error_message" value={vads_redirect_error_message} />
      <input type="hidden" name="vads_redirect_error_timeout" value={vads_redirect_error_timeout} />
      <input type="hidden" name="vads_redirect_success_message" value={vads_redirect_success_message} />
      <input type="hidden" name="vads_redirect_success_timeout" value={vads_redirect_success_timeout} />
      <input type="hidden" name="vads_return_mode" value={vads_return_mode} />
      <input type="hidden" name="vads_site_id" value={vads_site_id} />
      <input type="hidden" name="vads_trans_date" value={vads_trans_date} />
      <input type="hidden" name="vads_trans_id" value={vads_trans_id} />
      <input type="hidden" name="vads_url_check" value={vads_url_check} />
      <input type="hidden" name="vads_version" value={vads_version} />
      <input type="hidden" name="vads_ext_info_transac" value={vads_ext_info_transac} />
      <input type="hidden" name="signature" value={signatureSHA1} />

      <Button
        style={{ height: '51px' }}
        fullWidth
        color="primary"
        variant="contained"
        type="submit"
        disableElevation
        disabled={disabled}
      >Payer en 10x {montantx10} €</Button>
    </form>
  )
}